import styled, { css } from 'styled-components'
import { Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'

const ButtonLarge = ({ theme }: any) => css`
  && {
    font-size: ${theme.typograph.fontsize.h3};
    font-family: ${theme.typograph.fontFamily.primary};
    width: auto;
    border-radius: 0px;
    padding: ${theme.layout.padding.medium} ${theme.layout.padding.base * 5}rem;

    &.MuiButton-outlined {
      color: ${theme.colors.primary.main};
      border-color: ${theme.colors.primary.main};
    }

    &.MuiButton-contained {
      background-color: ${theme.colors.primary.main};
    }

    &.Mui-disabled {
      background-color: ${theme.colors.base.white};
      border: 0.1rem solid;
      svg {
        color: ${theme.colors.base.gray};
      }
    }
    @media (max-width: ${theme.screen.small}) {
      font-size: ${theme.typograph.fontsize.h2};
    }
  }
`

export const ButtonComponent = styled(Button)(ButtonLarge)

export const LoadingButtonComponent = styled(LoadingButton)(ButtonLarge)
